import { Component } from '@angular/core';
import { UtmService } from '@core/services/utm.service';
import { NgIf } from '@angular/common';

@Component({
    selector: 'safarmarket-pixel',
    standalone: true,
    imports: [NgIf],
    template: `
    <img title="safarmarket" id="safarmarket-pixel" *ngIf="utmService.safarmarketId()" [src]="'https://safarmarket.com/api/hotel/v1/pixel/iranhotelonline/2/0/?smId=' + utmService.safarmarketId()" style="width: 1px; height: 1px; opacity: 0">
  `
})
export class SafarmarketPixelComponent {
    constructor(
        public utmService: UtmService
    ) { }
}
